<template>
  <vue-tailwind-modal
    :showing="showModal"
    @close="$emit('close-modal')"
    :showClose="true"
    :backgroundClose="false"
    class='p-4'
  >
    <!-- Put your modal content here -->
    <h1 class="font-semibold text-md text-gray-500">
      {{ title }}
    </h1>
    <div class="my-5">
      <label
        for="copy-name"
        class="block text-sm font-medium leading-5 text-gray-700"
      >
        Name
      </label>
      <div class="mt-1 rounded-md shadow-sm">
        <input
          id="copy-name"
          v-model="copyName"
          class="appearance-none block w-full px-3 py-2 border
          border-gray-300 rounded-md placeholder-gray-400
          focus:outline-none focus:shadow-outline-blue
          focus:border-blue-300 transition duration-150 ease-in-out
          sm:text-sm sm:leading-5"
        />
      </div>
    </div>
    <div class="my-4 flex justify-end">
      <c-button size='small' :loading="loading" @click="$emit('save', copyName)">Save</c-button>
    </div>
  </vue-tailwind-modal>
</template>

<script>
import CButton from '@/components/Core/CButton'
export default {
  components: {
    CButton
  },
  props: ["showModal", 'title', 'name', 'loading'],
  data(){
    return {
      copyName: `Copy of ${this.name}`
    }
  },
}
</script>
